// LAYOUT
import BlankLayout from 'src/layouts/BlankLayout.vue'
import MainLayout from 'src/layouts/MainLayout.vue'
import AuthLayout from 'src/layouts/AuthLayout.vue'
import BlankMainLayout from 'src/layouts/BlankMainLayout.vue'

const routes = [
  {
    path: '/',
    component: () => import('src/layouts/BlankLayout.vue'),
    children: [
      {
        path: '',
        component: MainLayout,
        meta: {
          type: 'main'
        },
        children: [
          // ---------------
          // Playground
          // ---------------
          {
            path: '/playground',
            name: 'playground',
            alias: '/playground',
            component: () => import('src/pages/Playground.vue'),
            meta: {
              icon: require('src/assets/images/icons/graph.svg'),
              requireAuth: true,
              tag: 'DASHBOARD:R',
              activeMenu: 'dashboard',
              name: 'Dasbor',
              read: true,
              write: false
            }
          },

          // ---------------
          // DASHBOARD
          // ---------------
          {
            path: '/',
            name: 'dashboard',
            alias: '/dashboard',
            component: () => import('src/pages/dashboard/Index.vue'),
            meta: {
              icon: require('src/assets/images/icons/graph.svg'),
              requireAuth: true,
              tag: 'DASHBOARD:R',
              activeMenu: 'dashboard',
              name: 'Dasbor',
              read: true,
              write: false
            }
          },

          // ---------------
          // CUSTOMER
          // ---------------
          {
            path: '/customer',
            component: BlankLayout,
            meta: {
              collapse: true,
              icon: require('src/assets/images/icons/profile-2user.svg'),
              requireAuth: true,
              tag: 'CUSTOMER:R',
              activeMenu: 'customer',
              name: 'Customer',
              read: true,
              write: false
            },
            children: [
              {
                path: '',
                name: 'customer',
                component: () => import('src/pages/customer/Index.vue'),
                meta: {
                  subMenu: true,
                  icon: null,
                  requireAuth: true,
                  tag: 'CUSTOMER:R',
                  activeMenu: 'customer',
                  name: 'Daftar Customer',
                  read: true,
                  write: false
                }
              },
              {
                path: 'form/:action',
                name: 'customer-form',
                title: 'Customer',
                component: () => import('src/pages/customer/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'CUSTOMER:W',
                  activeMenu: 'customer',
                  name: 'Daftar Customer',
                  read: true,
                  write: true
                }
              },
              {
                path: 'detail/:action/:id?/:isVerified?/:type?/:companyId?',
                name: 'customer-detail',
                title: 'Customer',
                component: () => import('src/pages/customer/Detail.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'CUSTOMER:W',
                  activeMenu: 'customer',
                  name: 'Daftar Customer',
                  read: true,
                  write: true
                }
              },

              // --------
              // UPGRADE
              // --------
              {
                path: 'detail/:action/:id?/:isVerified?/:type?/:companyId?/upgrade-grade',
                name: 'customer-upgrade-grade',
                title: 'Upgrade Grade',
                component: () => import('src/pages/customer/UpgradeGrade.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'CUSTOMER:W',
                  activeMenu: 'customer',
                  name: 'Daftar Customer',
                  read: true,
                  write: true
                }
              },
              {
                path: 'detail/:action/:id?/:isVerified?/:type?/:companyId?/upgrade-limit/:submissionId?',
                name: 'customer-upgrade-limit',
                title: 'Upgrade Limit',
                component: () => import('src/pages/customer/UpgradeLimit.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'CUSTOMER:W',
                  activeMenu: 'customer',
                  name: 'Daftar Customer',
                  read: true,
                  write: true
                }
              },
              {
                path: 'upgrade/:id?/:isVerified?/:type?/:companyId?',
                name: 'customer-form-upgrade',
                props: true,
                component: () => import('src/pages/customer/Upgrade.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'CUSTOMER:W',
                  activeMenu: 'customer',
                  name: 'Daftar Customer',
                  read: true,
                  write: true
                }
              },
              {
                path: 'submission',
                name: 'customer-submission',
                component: () => import('src/pages/customer/Submision.vue'),
                meta: {
                  subMenu: true,
                  icon: null,
                  requireAuth: true,
                  tag: 'CUSTOMER:R',
                  activeMenu: 'customer-submission',
                  name: 'Daftar Pengajuan',
                  read: true,
                  write: false
                }
              },
              {
                path: 'submission/detail/:action?/:bnplName?/:companyId',
                name: 'customer-submission-detail',
                component: () =>
                  import('src/pages/customer/components/Submission/Detail.vue'),
                meta: {
                  subMenu: true,
                  icon: null,
                  requireAuth: true,
                  tag: 'CUSTOMER:R',
                  activeMenu: 'customer-submission',
                  name: 'Daftar Pengajuan',
                  read: true,
                  write: false
                }
              },
              {
                path: 'submission/detail/:action?/:bnplName/:companyId/complete-address',
                name: 'customer-submission-credilinq-complete-address',
                component: () =>
                  import(
                    'src/pages/customer/components/Submission/FormCredilinqCompleteAddress.vue'
                  ),
                meta: {
                  subMenu: true,
                  icon: null,
                  requireAuth: true,
                  tag: 'CUSTOMER:R',
                  activeMenu: 'customer-submission',
                  name: 'Daftar Pengajuan',
                  read: true,
                  write: false
                }
              }
            ]
          },

          // ---------------
          // SKU
          // ---------------
          {
            path: '/sku',
            component: BlankLayout,
            meta: {
              collapse: true,
              name: 'SKU',
              icon: require('src/assets/images/icons/qr-code.svg'),
              requireAuth: true,
              tag: 'SKU:R',
              activeMenu: 'sku',
              read: true,
              write: false
            },
            children: [
              {
                path: '',
                name: 'sku',
                component: () => import('src/pages/sku/main/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Daftar SKU',
                  icon: null,
                  requireAuth: true,
                  tag: 'SKU:R',
                  activeMenu: 'sku',
                  read: true,
                  write: false
                }
              },
              {
                path: 'form/:action?/:id?/:name?',
                name: 'sku-form',
                component: () => import('src/pages/sku/main/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'SKU:W',
                  activeMenu: 'sku',
                  name: 'Daftar SKU',
                  read: true,
                  write: true
                }
              },
              {
                path: 'profit-target/brand/form/:action?/:id?/:name?',
                name: 'sku-form',
                component: () =>
                  import('src/pages/sku/profit-target/tabs/brand/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'SKU:W',
                  activeMenu: 'sku',
                  name: 'Daftar SKU',
                  read: true,
                  write: true
                }
              },
              {
                path: 'submission',
                name: 'sku-submission',
                component: () => import('src/pages/sku/submission/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Pengajuan SKU',
                  icon: null,
                  requireAuth: true,
                  tag: 'SKU:R',
                  activeMenu: 'sku-submission',
                  read: true,
                  write: false
                }
              },
              {
                path: 'submission/detail/:action?/:id?/:name?',
                name: 'sku-submission-detail',
                component: () => import('src/pages/sku/submission/Detail.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'SKU:W',
                  activeMenu: 'sku-submission',
                  name: 'Pengajuan SKU',
                  read: true,
                  write: true
                }
              },
              {
                path: 'category',
                name: 'sku-category',
                component: () => import('src/pages/sku/category/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Daftar Kategori',
                  icon: null,
                  requireAuth: true,
                  tag: 'SKU:R',
                  activeMenu: 'sku-category',
                  read: true,
                  write: false
                }
              },
              {
                path: 'category/form/:action?',
                name: 'sku-category-form',
                component: () => import('src/pages/sku/category/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'SKU:W',
                  activeMenu: 'sku-category',
                  name: 'Daftar Kategori',
                  read: true,
                  write: true
                }
              },
              {
                path: 'category/form-category/:action?/:categoryNumber?/:id?/:name?',
                name: 'sku-category-form-fields',
                component: () =>
                  import('src/pages/sku/category/FormFields.vue'),
                props: (route) => ({
                  categoryNumber: Number(route.params.categoryNumber),
                  id: Number(route.params.id),
                  name: route.params.name
                }),
                meta: {
                  requireAuth: true,
                  tag: 'SKU:W',
                  activeMenu: 'sku-category',
                  name: 'Daftar Kategori',
                  read: true,
                  write: true
                }
              },
              {
                path: 'unit',
                name: 'sku-unit',
                component: () => import('src/pages/sku/unit/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Satuan',
                  icon: null,
                  requireAuth: true,
                  tag: 'SKU:R',
                  activeMenu: 'sku-unit',
                  read: true,
                  write: false
                }
              },
              {
                path: 'brand',
                name: 'sku-brand',
                component: () => import('src/pages/sku/brand/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Merek',
                  icon: null,
                  requireAuth: true,
                  tag: 'SKU:R',
                  activeMenu: 'sku-brand',
                  read: true,
                  write: false
                }
              },
              {
                path: 'brand/form/:action?/:id?/:name?',
                name: 'sku-brand-form',
                component: () => import('src/pages/sku/brand/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'SKU:W',
                  activeMenu: 'sku-brand',
                  name: 'Merek',
                  read: true,
                  write: true
                }
              },
              {
                path: 'variant',
                name: 'sku-variant',
                component: () => import('src/pages/sku/variant/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Jenis Varian',
                  icon: null,
                  requireAuth: true,
                  tag: 'SKU:R',
                  activeMenu: 'sku-variant',
                  read: true,
                  write: false
                }
              },
              {
                path: 'discount',
                name: 'sku-discount',
                component: () => import('src/pages/sku/discount/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Tabel Diskon Tier',
                  icon: null,
                  requireAuth: true,
                  tag: 'SKU:R',
                  activeMenu: 'sku-discount',
                  read: true,
                  write: false
                }
              },
              {
                path: 'profit-target',
                component: () =>
                  import('src/pages/sku/profit-target/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Target Profit',
                  icon: null,
                  requireAuth: true,
                  tag: 'SKU:R',
                  activeMenu: 'sku-profit-target',
                  read: true,
                  write: false
                },
                children: [
                  // TAB SKU
                  {
                    path: 'approval',
                    name: 'sku-profit-target-approval',
                    component: () =>
                      import(
                        'src/pages/sku/profit-target/tabs/sku/Approval.vue'
                      ),
                    meta: {
                      name: 'Target Profit',
                      requireAuth: true,
                      tag: 'SKU:R',
                      activeMenu: 'sku-profit-target-approval',
                      read: true,
                      write: false
                    }
                  },
                  {
                    path: ':action?',
                    name: 'sku-profit-target',
                    component: () =>
                      import('src/pages/sku/profit-target/tabs/sku/Index.vue'),
                    meta: {
                      name: 'Target Profit',
                      requireAuth: true,
                      tag: 'SKU:R',
                      activeMenu: 'sku-profit-target',
                      read: true,
                      write: false
                    }
                  },

                  // TAB BRAND
                  {
                    path: 'brand/:action?',
                    name: 'sku-profit-target-brand',
                    component: () =>
                      import(
                        'src/pages/sku/profit-target/tabs/brand/Index.vue'
                      ),
                    meta: {
                      name: 'Target Profit',
                      requireAuth: true,
                      tag: 'SKU:R',
                      activeMenu: 'sku-profit-target',
                      read: true,
                      write: false
                    }
                  },

                  // TAB CATEGORY 3
                  {
                    path: 'category3/:action?',
                    name: 'sku-profit-target-category',
                    component: () =>
                      import(
                        'src/pages/sku/profit-target/tabs/category3/Index.vue'
                      ),
                    meta: {
                      name: 'Target Profit',
                      requireAuth: true,
                      tag: 'SKU:R',
                      activeMenu: 'sku-profit-target',
                      read: true,
                      write: false
                    }
                  }
                ]
              }
            ]
          },

          // ---------------
          // VENDOR
          // ---------------
          {
            path: '',
            component: BlankLayout,
            meta: {
              requireAuth: true,
              tag: 'VENDOR:R',
              activeMenu: 'vendor',
              name: 'Vendor',
              read: true,
              write: false
            },
            children: [
              {
                path: '/vendor',
                name: 'vendor',
                component: () => import('src/pages/vendor/Index.vue'),
                meta: {
                  name: 'Vendor',
                  icon: require('src/assets/images/icons/ic-ecommerce-house.svg'),
                  requireAuth: true,
                  tag: 'VENDOR:R',
                  activeMenu: 'vendor',
                  read: true,
                  write: false
                }
              },
              {
                path: '/vendor/form/:action?/:id?/:name?',
                name: 'vendor-form',
                component: () => import('src/pages/vendor/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'VENDOR:W',
                  activeMenu: 'vendor',
                  name: 'Vendor',
                  read: true,
                  write: true
                }
              }
              // {
              //   path: '/vendor/form/:action?/:id?/:name?/:adds?',
              //   name: 'invite-form',
              //   component: InviteForm,
              //   meta: {
              //     requireAuth: true,
              //     tag: 'VENDOR:W',
              //     activeMenu: 'vendor'
              //   }
              // }
            ]
          },

          // ---------------
          // PRODUCT
          // ---------------
          {
            path: '',
            component: BlankLayout,
            meta: {
              collapse: true,
              requireAuth: true,
              tag: 'PRODUCT:R',
              activeMenu: 'product',
              name: 'Produk',
              read: true,
              write: false,
              icon: require('src/assets/images/icons/box.svg')
            },
            children: [
              {
                path: '/product',
                name: 'product',
                component: () => import('src/pages/product/Index.vue'),
                meta: {
                  name: 'Daftar Produk',
                  subMenu: true,
                  icon: require('src/assets/images/icons/box.svg'),
                  requireAuth: true,
                  tag: 'PRODUCT:R',
                  activeMenu: 'product',
                  read: true,
                  write: false
                }
              },
              {
                path: '/product/form/edit/bulk-price',
                name: 'product-form-edit-bulk-price',
                component: () =>
                  import('src/pages/product/bulk-price/Index.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'PRODUCT:W',
                  activeMenu: 'product',
                  name: 'Daftar Produk',
                  read: true,
                  write: true
                }
              },
              {
                path: '/product/form/:action?/:id?/:name?',
                name: 'product-form',
                component: () => import('src/pages/product/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'PRODUCT:W',
                  activeMenu: 'product',
                  name: 'Daftar Produk',
                  read: true,
                  write: true
                }
              },
              {
                path: 'product-submission',
                name: 'product-submission',
                component: () =>
                  import('src/pages/product/submission/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Pengajuan Harga',
                  icon: null,
                  requireAuth: true,
                  tag: 'PRODUCT:R',
                  activeMenu: 'product-submission',
                  read: true,
                  write: false
                }
              }
            ]
          },

          // ---------------
          // CoA
          // ---------------
          {
            path: '',
            component: BlankLayout,
            meta: {
              requireAuth: true,
              tag: 'COA:R',
              activeMenu: 'coa',
              name: 'CoA',
              read: true,
              write: false
            },
            children: [
              {
                path: '/coa',
                name: 'coa',
                component: () => import('src/pages/coa/Index.vue'),
                meta: {
                  name: 'CoA',
                  icon: require('src/assets/images/icons/receipt.svg'),
                  requireAuth: true,
                  tag: 'COA:R',
                  activeMenu: 'coa',
                  read: true,
                  write: false
                }
              },
              {
                path: '/coa/form',
                name: 'coa-form',
                component: () => import('src/pages/coa/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'COA:W',
                  activeMenu: 'coa',
                  name: 'CoA',
                  read: true,
                  write: true
                }
              }
            ]
          },

          // ---------------
          // TRANSACTION
          // ---------------
          {
            path: '',
            component: BlankLayout,
            meta: {
              collapse: true,
              name: 'Transaksi',
              icon: require('src/assets/images/icons/shopping-cart.svg'),
              requireAuth: true,
              tag: 'TRANSACTION',
              activeMenu: 'so',
              read: true,
              write: false
            },
            children: [
              {
                name: 'monitoring-flow',
                path: '/monitoring-flow',
                component: () =>
                  import('src/pages/transaction/monitoring-flow/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Monitoring Flow',
                  icon: null,
                  requireAuth: true,
                  tag: 'TRANSACTION_SO:R',
                  activeMenu: 'monitoring-flow',
                  read: true,
                  write: false
                }
              },

              // ---------------
              // NEGO
              // ---------------
              {
                path: '/nego',
                component: BlankLayout,
                meta: {
                  subMenu: true,
                  name: 'Daftar Negosiasi',
                  icon: null,
                  requireAuth: true,
                  tag: 'TRANSACTION_SO:R',
                  activeMenu: 'nego',
                  read: true,
                  write: false
                },
                children: [
                  {
                    path: '',
                    name: 'nego',
                    component: () =>
                      import('src/pages/transaction/nego/Index.vue'),
                    meta: {
                      name: 'Daftar Negosiasi',
                      requireAuth: true,
                      tag: 'TRANSACTION_SO:R',
                      activeMenu: 'nego',
                      read: true,
                      write: false
                    }
                  },
                  {
                    path: '/nego/detail/:action?/:id?/:name?',
                    name: 'nego-detail',
                    props: true,
                    component: () =>
                      import('src/pages/transaction/nego/Detail.vue'),
                    meta: {
                      requireAuth: true,
                      tag: 'TRANSACTION_SO:W',
                      activeMenu: 'nego',
                      name: 'Daftar Negosiasi',
                      read: true,
                      write: true
                    }
                  }
                ]
              },

              {
                path: '/so',
                component: BlankLayout,
                meta: {
                  subMenu: true,
                  name: 'Sales Order',
                  icon: null,
                  requireAuth: true,
                  tag: 'TRANSACTION_SO:R',
                  activeMenu: 'so',
                  read: true,
                  write: false
                },
                children: [
                  {
                    path: '',
                    name: 'so',
                    component: () =>
                      import('src/pages/transaction/so/Index.vue'),
                    meta: {
                      name: 'Sales Order',
                      requireAuth: true,
                      tag: 'TRANSACTION_SO:R',
                      activeMenu: 'so',
                      read: true,
                      write: false
                    }
                  },
                  {
                    path: '/so/form/:action?/:id?/:name?',
                    name: 'so-form',
                    component: () =>
                      import('src/pages/transaction/so/Form.vue'),
                    meta: {
                      requireAuth: true,
                      tag: 'TRANSACTION_SO:W',
                      activeMenu: 'so',
                      name: 'Sales Order',
                      read: true,
                      write: true
                    }
                  },
                  {
                    path: '/so/draft/:action?/:id?/:name?',
                    name: 'so-draft',
                    component: () =>
                      import('src/pages/transaction/so/Form.vue'),
                    meta: {
                      requireAuth: true,
                      tag: 'TRANSACTION_SO:W',
                      activeMenu: 'so',
                      name: 'Sales Order',
                      read: true,
                      write: true
                    }
                  },
                  {
                    path: '/so/detail/:id?/:name?',
                    name: 'so-detail',
                    component: () =>
                      import('src/pages/transaction/so/Detail.vue'),
                    meta: {
                      requireAuth: true,
                      tag: 'TRANSACTION_SO:R',
                      activeMenu: 'so',
                      name: 'Sales Order',
                      read: true,
                      write: false
                    }
                  }
                ]
              },
              {
                path: '/po',
                component: BlankLayout,
                meta: {
                  subMenu: true,
                  name: 'Purchase Order',
                  icon: null,
                  requireAuth: true,
                  tag: 'TRANSACTION_PO:R',
                  activeMenu: 'po',
                  read: true,
                  write: false
                },
                children: [
                  {
                    path: '',
                    name: 'po',
                    component: () => import('src/pages/po/Index.vue'),
                    meta: {
                      name: 'Purchase Order',
                      requireAuth: true,
                      tag: 'TRANSACTION_PO:R',
                      activeMenu: 'po',
                      read: true,
                      write: false
                    }
                  },
                  {
                    path: '/po/form/:action?/:id?/:name?',
                    name: 'po-form',
                    component: () => import('src/pages/po/Form.vue'),
                    meta: {
                      requireAuth: true,
                      tag: 'TRANSACTION_PO:W',
                      activeMenu: 'po',
                      name: 'Purchase Order',
                      read: true,
                      write: true
                    }
                  },
                  {
                    path: '/po/detail/:id?/:name?',
                    name: 'po-detail',
                    component: () => import('src/pages/po/Detail.vue'),
                    meta: {
                      requireAuth: true,
                      tag: 'TRANSACTION_PO:W',
                      activeMenu: 'po',
                      name: 'Purchase Order',
                      read: true,
                      write: true
                    }
                  }
                ]
              },
              {
                path: '/do',
                component: BlankLayout,
                meta: {
                  subMenu: true,
                  name: 'Delivery Order',
                  icon: null,
                  requireAuth: true,
                  tag: 'TRANSACTION_PO:R',
                  activeMenu: 'do',
                  read: true,
                  write: false
                },
                children: [
                  {
                    path: '',
                    name: 'do',
                    component: () =>
                      import('src/pages/transaction/do/Index.vue'),
                    meta: {
                      name: 'Delivery Order',
                      requireAuth: true,
                      tag: 'TRANSACTION_PO:R',
                      activeMenu: 'do',
                      read: true,
                      write: false
                    }
                  },
                  {
                    path: '/do/form/:action?/:id?/:name?',
                    name: 'do-form',
                    component: () =>
                      import('src/pages/transaction/do/Form.vue'),
                    meta: {
                      requireAuth: true,
                      tag: 'TRANSACTION_PO:W',
                      activeMenu: 'do',
                      name: 'Delivery Order',
                      read: true,
                      write: true
                    }
                  },
                  {
                    path: '/do/detail/:id?/:name?',
                    name: 'do-detail',
                    component: () =>
                      import('src/pages/transaction/do/Detail.vue'),
                    meta: {
                      requireAuth: true,
                      tag: 'TRANSACTION_PO:R',
                      activeMenu: 'do',
                      name: 'Delivery Order',
                      read: true,
                      write: false
                    }
                  },
                  {
                    path: '/do/detail/:id?/:name?/upload-shipment-pickup-receipt',
                    name: 'do-upload-shipment-pickup-receipt',
                    component: () =>
                      import(
                        'src/pages/transaction/do/UploadShipmentOrPickupReceipt.vue'
                      ),
                    meta: {
                      requireAuth: true,
                      tag: 'TRANSACTION_PO:R',
                      activeMenu: 'do',
                      name: 'Delivery Order',
                      read: true,
                      write: true
                    }
                  }
                ]
              },
              // {
              //   name: 'confirm-payment',
              //   path: '/transaction/confirm-payment',
              //   component: () =>
              //     import('src/pages/transaction/confirm-payment/Index.vue'),
              //   meta: {
              //     subMenu: true,
              //     title: 'Daftar Konfirmasi Pembayaran',
              //     icon: null,
              //     requireAuth: true,
              //     tag: 'FINANCE:R',
              //     activeMenu: 'confirm-payment'
              //   }
              // },

              // ---------------
              // INVOICE
              // ---------------
              {
                path: '/invoice',
                name: 'invoice',
                component: () =>
                  import('src/pages/transaction/invoice-list/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Daftar Invoice',
                  icon: null,
                  requireAuth: true,
                  tag: 'FINANCE:R',
                  activeMenu: 'invoice',
                  read: true,
                  write: false
                }
              },
              {
                path: '/invoice/detail/:id?/:name?',
                name: 'invoice-detail',
                component: () =>
                  import('src/pages/transaction/invoice-list/Detail.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'FINANCE:W',
                  activeMenu: 'invoice',
                  name: 'Daftar Invoice',
                  read: true,
                  write: true
                }
              },
              {
                path: '/invoice/exchange/form/:action?/:id?/:name?',
                name: 'exchange-invoice-form',
                component: () =>
                  import('src/pages/transaction/invoice-list/Form.vue'),
                // D:src/pages/transaction/so/Form.vue
                // D:src/pages/transaction/invoice-list/Form.vue
                meta: {
                  tag: 'EXCHANGE_INVOICE:W',
                  activeMenu: 'invoice',
                  name: 'Exchange Invoice',
                  read: true,
                  write: true
                }
              },
              {
                path: '/invoice/compare/:doId/:name?',
                name: 'invoice-nonMade-compare',
                component: () =>
                  import('src/pages/transaction/invoice-list/Compare.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'FINANCE:W',
                  activeMenu: 'invoice',
                  name: 'Daftar Invoice',
                  read: true,
                  write: true
                }
              },
              // {
              //   name: 'tax-invoice',
              //   path: '/transaction/tax-invoice',
              //   component: () =>
              //     import('src/pages/transaction/tax-invoice/Index.vue'),
              //   meta: {
              //     subMenu: true,
              //     title: 'Daftar Faktur Pajak',
              //     icon: null,
              //     requireAuth: true,
              //     tag: 'FINANCE:R',
              //     activeMenu: 'tax-invoice'
              //   }
              // },

              // ---------------
              // RETURN-LETTER
              // ---------------
              {
                path: '/transaction/return-letter',
                component: BlankLayout,
                meta: {
                  subMenu: true,
                  name: 'Surat Jalan Balik',
                  icon: null,
                  requireAuth: true,
                  tag: 'FINANCE:R',
                  activeMenu: 'return-letter',
                  read: true,
                  write: false
                },
                children: [
                  {
                    path: '',
                    name: 'return-letter',
                    component: () =>
                      import(
                        'src/pages/transaction/do-return-letter/Index.vue'
                      ),
                    meta: {
                      name: 'Surat Jalan Balik',
                      requireAuth: true,
                      tag: 'FINANCE:R',
                      activeMenu: 'return-letter',
                      read: true,
                      write: false
                    }
                  },
                  {
                    path: '/transaction/return-letter/form/:action?/:id?/:type?',
                    name: 'return-letter-form',
                    props: true,
                    component: () =>
                      import('src/pages/transaction/do-return-letter/Form.vue'),
                    meta: {
                      requireAuth: true,
                      tag: 'FINANCE:W',
                      activeMenu: 'return-letter',
                      name: 'Surat Jalan Balik',
                      read: true,
                      write: true
                    }
                  }
                ]
              }
            ]
          },

          // ---------------
          // FINANCIAL
          // ---------------
          {
            path: '',
            component: BlankLayout,
            meta: {
              collapse: true,
              name: 'Finansial',
              icon: require('src/assets/images/icons/card.svg'),
              requireAuth: true,
              tag: 'FINANCE',
              activeMenu: 'financial',
              read: true,
              write: false
            },
            children: [
              // Root `/financial` will open Biaya & Pendapatan page
              {
                path: '/financial',
                name: 'cost-income',
                component: () =>
                  import('src/pages/financial/cost-income/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Biaya & Pendapatan',
                  icon: null,
                  requireAuth: true,
                  tag: 'FINANCE:R',
                  activeMenu: 'cost-income',
                  read: true,
                  write: false
                }
              },
              {
                path: '/financial/profit-loss',
                name: 'profit-loss',
                component: () =>
                  import('src/pages/financial/profit-loss/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Laba Rugi Detail',
                  icon: null,
                  requireAuth: true,
                  tag: 'FINANCE:R',
                  activeMenu: 'profit-loss',
                  read: true,
                  write: false
                }
              }
            ]
          },

          // ---------------
          // ADMIN
          // ---------------
          {
            path: '',
            component: BlankLayout,
            meta: {
              collapse: true,
              name: 'Admin',
              icon: require('src/assets/images/icons/personalcard.svg'),
              requireAuth: true,
              tag: 'ADMIN',
              activeMenu: 'admin',
              read: true,
              write: false
            },
            children: [
              {
                path: '/admin',
                name: 'admin',
                component: () => import('src/pages/admin/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'User Management',
                  icon: null,
                  requireAuth: true,
                  tag: 'ADMIN:R',
                  activeMenu: 'admin',
                  read: true,
                  write: false
                }
              },

              {
                path: '/admin/form/:action?/:id?/:name?',
                name: 'admin-form',
                component: () => import('src/pages/admin/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'ADMIN:W',
                  activeMenu: 'admin',
                  name: 'User Management',
                  read: true,
                  write: true
                }
              },

              {
                path: '/admin-access',
                name: 'admin-access',
                component: () => import('src/pages/admin/access/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Daftar Akses Admin',
                  icon: null,
                  requireAuth: true,
                  tag: 'ADMIN:R',
                  activeMenu: 'admin-access',
                  read: true,
                  write: false
                }
              },

              {
                path: '/admin-access/form/:action?/:id?/:name?',
                name: 'admin-access-form',
                component: () => import('src/pages/admin/access/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'ADMIN:W',
                  activeMenu: 'admin-access',
                  name: 'Daftar Akses Admin',
                  read: true,
                  write: false
                }
              }
            ]
          },

          // ---------------
          // PARTNER
          // ---------------
          {
            path: '/partner',
            component: BlankLayout,
            meta: {
              collapse: true,
              name: 'Mitra Sales',
              icon: require('src/assets/images/icons/people.svg'),
              requireAuth: true,
              tag: 'PARTNER',
              activeMenu: 'partner',
              read: true,
              write: false
            },
            children: [
              {
                path: '',
                name: 'partner',
                component: () => import('src/pages/partner/main/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Daftar Sales',
                  icon: null,
                  requireAuth: true,
                  tag: 'PARTNER:R',
                  activeMenu: 'partner',
                  read: true,
                  write: false
                }
              },
              {
                path: 'form/:action?/:id?/:name?',
                name: 'partner-form',
                component: () => import('src/pages/partner/main/Form.vue'),
                meta: {
                  requireAuth: true,
                  tag: 'PARTNER:W',
                  activeMenu: 'partner',
                  name: 'Daftar Sales',
                  read: true,
                  write: true
                }
              }
            ]
          },
          // ---------------
          // PROFILE
          // ---------------
          {
            path: '',
            component: BlankLayout,
            meta: {
              collapse: true,
              name: 'Profil',
              icon: require('src/assets/images/icons/profile-circle.svg'),
              requireAuth: true,
              tag: 'PROFILE',
              activeMenu: 'profile',
              read: true,
              write: false
            },
            children: [
              {
                path: '/profile',
                name: 'profile',
                component: () => import('src/pages/profile/Index.vue'),
                meta: {
                  subMenu: true,
                  name: 'Lihat Profil',
                  icon: null,
                  requireAuth: true,
                  tag: 'PROFILE:R',
                  activeMenu: 'profile',
                  read: true,
                  write: false
                }
              }
            ]
          }
        ]
      },

      // Page without navbar and sidebar.
      {
        path: '',
        component: BlankMainLayout,
        meta: {
          type: 'main'
        },
        children: [
          {
            path: '/customer',
            component: BlankLayout,
            children: [
              {
                path: 'upgrade-to-business/:id',
                name: 'customer-form-upgrade-to-business',
                props: true,
                component: () =>
                  import('src/pages/customer/upgrade-to-business/Index.vue')
              }
            ]
          }
        ]
      },

      {
        path: '',
        name: 'auth',
        component: AuthLayout,
        meta: {
          type: 'auth',
          activeMenu: 'auth'
        },
        children: [
          {
            path: '/login',
            name: 'authLogin',
            component: () => import('src/pages/auth/Login.vue'),
            meta: {
              requireAuth: false,
              tag: 'LOGIN',
              activeMenu: 'authLogin'
            }
          },
          {
            path: 'verify/email/:token?',
            name: 'verify',
            component: () => import('src/pages/auth/Verify.vue'),
            meta: {
              requireAuth: false,
              tag: 'VERIFY',
              activeMenu: 'authLogin'
            }
          },
          {
            path: 'reset-password/:token?',
            name: 'reset',
            component: () => import('src/pages/auth/Verify.vue'),
            meta: {
              requireAuth: false,
              tag: 'Reset',
              activeMenu: 'authLogin'
            }
          },
          {
            path: '/forgot-password',
            name: 'forgotPassword',
            alias: '/forgotPassword',
            component: () => import('src/pages/auth/ForgotPassword.vue'),
            meta: {
              requireAuth: false,
              tag: 'LOGIN',
              activeMenu: 'authLogin'
            }
          }
        ]
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
